import { render, staticRenderFns } from "./confirmationCourse.vue?vue&type=template&id=570d4d8b&scoped=true&"
import script from "./confirmationCourse.vue?vue&type=script&lang=js&"
export * from "./confirmationCourse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "570d4d8b",
  null
  
)

export default component.exports